import styled, { css } from 'styled-components'

const Time = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;

  ${(props) =>
    props.space &&
    css`
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 20px;
    `}

  ${(props) =>
    props.mb && props.mb == 'large' &&
    css`
      margin-bottom:40px;
    `}

  &:last-of-type {
   margin-bottom:40px;
  }
`

Time.Desc = styled.div`
   font-size: 16px;
   line-height: 1.6;
   color: var(--color-secondary);
`

Time.Link = styled.a`
  display: flex;
`

export default Time
